import {BaseGraphNode} from "#graph/nodes/base/base-graph-node"

export const isBaseGraphNodeInstance = (value: unknown): value is BaseGraphNode => {
    return value instanceof BaseGraphNode
}
